import { ApiError } from './http';

/**
 * Mutation meta for an action whose 401 is its own refusal, said on its page in the server's words
 * (allowing a device): the app asks `GET /me` again rather than taking it as the session's end.
 * Signing out on it sent a signed-in admin to sign-in and back, in a loop (prod, 2026-10-05).
 */
export const refusalOnPage = { refusalOnPage: true } as const;

/** True when `e` is a 401 from a mutation marked {@link refusalOnPage}. */
export function isRefusalOnPage(e: unknown, meta: Record<string, unknown> | undefined): boolean {
  return meta?.['refusalOnPage'] === true && e instanceof ApiError && e.unauthenticated;
}
